import styled from 'styled-components';
export const LoaderStyled = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 200px;
  background: transparent
    url('https://i.ibb.co/BsBYbXB/ezgif-com-gif-to-webp.webp') center;
  `;
